const sort = (
    value: Array<any> = [],
    sortParam = '',
    sortValueType: 'number' | 'string' | 'timestamp' = 'string'
    ) => {
    
    if (value.length === 0 || sortParam.length === 0) {
        return []
    }

    let sorted = []

    if (sortValueType === 'timestamp') {
        sorted = value.sort((a,b) =>  new Date(b[sortParam]).getTime() - new Date(a[sortParam]).getTime())
        return sorted
    }

    if (sortValueType === 'number') {
        sorted = value.sort((a,b) =>  b[sortParam] - a[sortParam])
        return sorted
    }


}

export default sort